import React, { Component, useEffect, useState, useRef, createRef } from 'react'

const MustAsterik = () => {
    return <span style={{color: 'red'}}>{`*`}</span>
}

export default MustAsterik